import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import PartnershipBanner from '../../components/pages/Partnership/PartnershipBanner/PartnershipBanner'
import Partners from '../../components/pages/Partnership/Partners/Partners'

const Partnership = () => {
  return (
    <div>
        <Navbar/>
        <PartnershipBanner/>
        <Partners/>
        <Footer/>
    </div>
  )
}

export default Partnership